import { Routes } from '@angular/router';
import { FormularioComponent } from './features/formulario/formulario.component';
import { AccessDeniedComponent } from './features/acces-denied/acces-denied.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/formulario',
    pathMatch: 'full'
  },
  {
    path: 'formulario',
    component: FormularioComponent,
    data: { title: 'Formulario Autorización - GEA' }
  },
  {
    path: 'acceso-documentacion-pendiente',
    loadComponent: () =>
      import('./features/acceso-documentacion-pendiente/acceso-documentacion-pendiente.component')
        .then(m => m.AccesoDocumentacionPendienteComponent),
    data: { title: 'Documentación Pendiente - GEA' }
  },
  {
    path: 'bandeja-recepcion',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/bandeja-recepcion/bandeja-recepcion.component')
        .then(m => m.BandejaRecepcionComponent),
    data: { title: 'Bandeja Autorizaciones - GEA' }
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: { title: 'Acceso Denegado - GEA' }
  },
  {
    path: 'session-expired',
    loadComponent: () =>
      import('./features/session-expired/session-expired.component')
        .then(m => m.SessionExpiredComponent),
    data: { title: 'Sesión Expirada - GEA' }
  }
];